import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { saveAs as importedSaveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';

const URL = environment.apiBaseUrl;

@Injectable()
export class SampleFileService {
  constructor(private http: HttpClient) {}

  public advisorFile() {
    return this.http
      .get(`${URL}sampleFile/1`, { responseType: 'blob' })
      .subscribe((res: any) => {
        const filename = 'advisors-import-sample.xls';
        importedSaveAs(res, filename);
      });
  }

  public managerFile() {
    return this.http
      .get(`${URL}sampleFile/3`, { responseType: 'blob' })
      .subscribe((res: any) => {
        const filename = 'managers-import-sample.xls';
        importedSaveAs(res, filename);
      });
  }

  public entryFile() {
    return this.http
      .get(`${URL}sampleFile/2`, { responseType: 'blob' })
      .subscribe((res: any) => {
        const filename = 'entries-import-sample.xls';
        importedSaveAs(res, filename);
      });
  }

  public reallocationEntryFile() {
    return this.http
      .get(`${URL}sampleFile/4`, { responseType: 'blob' })
      .subscribe((res: any) => {
        const filename = 'reallocation-import-sample.xls';
        importedSaveAs(res, filename);
      });
  }
}
